export function scrollToCard(selector: string, targetIndex: number): void {
  requestAnimationFrame(() => {
    const cards = Array.from(document.querySelectorAll<HTMLElement>(selector));
    const target = cards[targetIndex] ?? cards.at(-1);
    target?.scrollIntoView({ behavior: "instant", block: "start" });
  });
}

export function getTopmostCardIndex(selector: string): number {
  const cards = Array.from(document.querySelectorAll<HTMLElement>(selector));
  for (let i = 0; i < cards.length; i++) {
    if ((cards[i]?.getBoundingClientRect().top ?? 1) >= 0) return i;
  }
  // Every card is above the viewport: the visitor is past the end of the grid.
  return Math.max(0, cards.length - 1);
}
